import { useId, useState } from "react";
import type { InputHTMLAttributes } from "react";
import { cn } from "@/lib/utils";

export function Field({
  label,
  hint,
  className,
  value,
  onFocus,
  onBlur,
  ...props
}: { label: string; hint?: string } & InputHTMLAttributes<HTMLInputElement>) {
  const id = useId();
  const [focused, setFocused] = useState(false);
  const floated = focused || (value !== undefined && value !== "");

  return (
    <div className="relative">
      <label
        htmlFor={id}
        className={cn(
          "pointer-events-none absolute z-10 left-4 select-none transition-all duration-200 ease-out",
          floated
            ? "top-2.5 text-[10px] font-semibold text-[oklch(0.82_0.185_84)]"
            : "top-1/2 -translate-y-1/2 text-sm text-zinc-500 font-medium text-shadow-none",
        )}
      >
        {label}
      </label>
      <input
        {...props}
        id={id}
        value={value}
        placeholder=""
        onFocus={(e) => {
          setFocused(true);
          onFocus?.(e);
        }}
        onBlur={(e) => {
          setFocused(false);
          onBlur?.(e);
        }}
        className={cn(
          "w-full rounded-xl border border-border bg-card/40 px-4 pb-3.5 pt-6 text-sm text-foreground backdrop-blur-md outline-none transition-all",
          "focus:border-primary/60 focus:ring-4 focus:ring-primary/15",
          className,
        )}
      />
      {hint ? <span className="mt-1.5 block text-xs text-muted-foreground">{hint}</span> : null}
    </div>
  );
}

export function QuestionTitle({ children }: { children: React.ReactNode }) {
  return (
    <h3 className="mb-4 text-base font-semibold leading-relaxed tracking-tight sm:text-lg">
      {children}
    </h3>
  );
}
